// extracted by mini-css-extract-plugin
export default {"uploadContainer":"uploadfile_uploadContainer__iDc5B","uploadFileIcon":"uploadfile_uploadFileIcon__Hg1G4"};